import { initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

import firebaseConfig from "../firebaseConfig";
import {
  firebaseAppCheckSiteKey,
  isWalletAuthenticationFeatureEnabled,
} from "../config/runtimeConfig";

const FUNCTIONS_REGION = "europe-west1";

const app = initializeApp(firebaseConfig);
const appCheck = isWalletAuthenticationFeatureEnabled
  ? initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(firebaseAppCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    })
  : null;
const auth = getAuth(app);
const functions = getFunctions(app, FUNCTIONS_REGION);

try {
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const usingFlag = process.env.VUE_APP_USE_FUNCTIONS_EMULATOR === "true";
  const autoDetectLan =
    process.env.VUE_APP_AUTODETECT_FUNCTIONS_EMULATOR === "true";
  const isLocalLike =
    host === "localhost" || host === "127.0.0.1" || /^192\.168\./.test(host);
  const isProd = process.env.NODE_ENV === "production";
  const shouldUseEmulator =
    !isProd && (usingFlag || (autoDetectLan && isLocalLike));

  if (shouldUseEmulator) {
    connectFunctionsEmulator(functions, "localhost", 5001);
    // eslint-disable-next-line no-console
    console.log(
      `[firebase] Connected Functions to emulator at http://localhost:5001 (host='${host}', flag=${usingFlag}, autoDetect=${autoDetectLan})`,
    );
  } else if (!isProd) {
    // eslint-disable-next-line no-console
    console.log("[firebase] Using deployed Cloud Functions (emulator disabled)");
  }
} catch (error) {
  // eslint-disable-next-line no-console
  console.warn("[firebase] Functions emulator connection skipped:", error);
}

export { app, appCheck, auth, functions, FUNCTIONS_REGION };
